<div><label class="filter-title">Storage Sizes</label></div>
<fieldset aria-label="Storage Sizes">
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      (change)="onStorageSizeFilterChange([0, 74])"
      (keyup.enter)="onStorageSizeFilterChange([0, 74])">
      <span class="filter-label">Under 75 GB</span>
    </mat-checkbox>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      (change)="onStorageSizeFilterChange([75, 149])"
      (keyup.enter)="onStorageSizeFilterChange([75, 149])">
      <span class="filter-label">75 GB - 150 GB</span>
    </mat-checkbox>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      (change)="onStorageSizeFilterChange([150, 256])"
      (keyup.enter)="onStorageSizeFilterChange([150, 256])">
      <span class="filter-label">150 GB - 256 GB</span>
    </mat-checkbox>
  </div>
  <div>
    <mat-checkbox
      tabindex="0"
      class="result-filter-cb"
      (change)="onStorageSizeFilterChange([257, 5000])"
      (keyup.enter)="onStorageSizeFilterChange([257, 5000])">
      <span class="filter-label">Over 256 GB</span>
    </mat-checkbox>
  </div>
</fieldset>
